import { LOAD_STATE } from '@/shared/types'
import type { AuthorDetailResponse, NewsColumnPageResponse } from '@/server/types'
import { getAuthorDetailApi, getNewsColumnPageApi } from '@/server'

export function logicRankNewsAuthor() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref<NewsColumnPageResponse[]>([])
  const authorData = ref<AuthorDetailResponse | null>(null)

  async function getAuthorDetail(authorId: number) {
    try {
      const res = await getAuthorDetailApi(authorId)
      authorData.value = res.data
    }
    catch {}
  }
  async function getRankData(authorId: number) {
    const res = await useLoadState({
      state,
      key: `相关资讯`,
      onlyClient: true,
      fn: () => getNewsColumnPageApi({ currentPage: 1, pageSize: 5, authorId }),
    })

    if (res && res.data)
      data.value = res.data.list
  }

  return {
    state,
    data,
    authorData,
    getAuthorDetail,
    getRankData,
  }
}
